import { Grid, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import { CasesGeneralListActionsProps } from './props';
import { CASES_GENERAL_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const CasesGeneralListActions = ({
    id,
}: CasesGeneralListActionsProps) => {
    const navigate = useNavigate();
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        navigate(`${CASES_GENERAL_EDIT}/${id}/#CHANGE_STATUS`);
    };

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
